import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-radio',
  template:` <div *ngFor="let option of to.options" class="pl-1">
  <input type="radio" 
         [name]="id"
         attr.name="{{key}}"
         [formControl]="formControl" 
         [formlyAttributes]="field"
         [value]="option.id">
  <span class="pl-1">{{ option.text }}</span>
</div>`,
})
export class FormlyFieldRadio extends FieldType {
 
}